import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Emitter } from '../../../base/common/event.js';
import { Disposable } from '../../../base/common/lifecycle.js';
export var AbstractCodeEditorService = /*#__PURE__*/function (_Disposable) {
  _inherits(AbstractCodeEditorService, _Disposable);

  var _super = _createSuper(AbstractCodeEditorService);

  function AbstractCodeEditorService() {
    var _this;

    _classCallCheck(this, AbstractCodeEditorService);

    _this = _super.call(this);
    _this._onCodeEditorAdd = _this._register(new Emitter());
    _this.onCodeEditorAdd = _this._onCodeEditorAdd.event;
    _this._onCodeEditorRemove = _this._register(new Emitter());
    _this.onCodeEditorRemove = _this._onCodeEditorRemove.event;
    _this._onDiffEditorAdd = _this._register(new Emitter());
    _this._onDiffEditorRemove = _this._register(new Emitter());
    _this._modelProperties = new Map();
    _this._codeEditors = Object.create(null);
    _this._diffEditors = Object.create(null);
    return _this;
  }

  _createClass(AbstractCodeEditorService, [{
    key: "addCodeEditor",
    value: function addCodeEditor(editor) {
      this._codeEditors[editor.getId()] = editor;

      this._onCodeEditorAdd.fire(editor);
    }
  }, {
    key: "removeCodeEditor",
    value: function removeCodeEditor(editor) {
      if (delete this._codeEditors[editor.getId()]) {
        this._onCodeEditorRemove.fire(editor);
      }
    }
  }, {
    key: "listCodeEditors",
    value: function listCodeEditors() {
      var _this2 = this;

      return Object.keys(this._codeEditors).map(function (id) {
        return _this2._codeEditors[id];
      });
    }
  }, {
    key: "addDiffEditor",
    value: function addDiffEditor(editor) {
      this._diffEditors[editor.getId()] = editor;

      this._onDiffEditorAdd.fire(editor);
    }
  }, {
    key: "removeDiffEditor",
    value: function removeDiffEditor(editor) {
      if (delete this._diffEditors[editor.getId()]) {
        this._onDiffEditorRemove.fire(editor);
      }
    }
  }, {
    key: "listDiffEditors",
    value: function listDiffEditors() {
      var _this3 = this;

      return Object.keys(this._diffEditors).map(function (id) {
        return _this3._diffEditors[id];
      });
    }
  }, {
    key: "getFocusedCodeEditor",
    value: function getFocusedCodeEditor() {
      var editorWithWidgetFocus = null;
      var editors = this.listCodeEditors();

      var _iterator = _createForOfIteratorHelper(editors),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var editor = _step.value;

          if (editor.hasTextFocus()) {
            // bingo!
            return editor;
          }

          if (editor.hasWidgetFocus()) {
            editorWithWidgetFocus = editor;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return editorWithWidgetFocus;
    }
  }, {
    key: "setModelProperty",
    value: function setModelProperty(resource, key, value) {
      var key1 = resource.toString();
      var dest;

      if (this._modelProperties.has(key1)) {
        dest = this._modelProperties.get(key1);
      } else {
        dest = new Map();

        this._modelProperties.set(key1, dest);
      }

      dest.set(key, value);
    }
  }, {
    key: "getModelProperty",
    value: function getModelProperty(resource, key) {
      var key1 = resource.toString();

      if (this._modelProperties.has(key1)) {
        var innerMap = this._modelProperties.get(key1);

        return innerMap.get(key);
      }

      return undefined;
    }
  }]);

  return AbstractCodeEditorService;
}(Disposable);